<template>
    <div class="wrapper">
        <div class="action-feedback">
            <dots id="dots"></dots>
            <h1 class="page-title">Feedback</h1>
            
            <div class="question-item" v-for="(question, i) in actionFeedback" :key="'q-' + i">
                <h4 class="general-feedback" v-if="question.response" v-html="question.response"></h4>
                
                <div class="feedback-item" v-for="(opt, i) in question.options" :key="'o-' + i">
                    
                    <div class="feedback-item-choice">
                        <label>Your Choice</label>
                        <h3 v-html="opt.question"></h3>
                    </div>
                    <div class="feedback-item-response">
                        <label>Response</label>
                        <div v-html="opt.response"></div>
                    </div>
                </div>
            </div>

            <div class="sticky-footer">
                <button class="btn center noselect" @click="animateOut">Continue</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { gsap } from '/src/assets/js/gsap';
import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin';
import Dots from '../components/Dots.vue';

export default {
    components: { Dots },
    name: "ActionFeedback",
    methods: {
        animateOut() {
            gsap.to('#dots, h1, .feedback-item, button', {
                autoAlpha : 0,
                stagger : {amount: 0.35},
                ease : "sine.in"
            })
            gsap.delayedCall(1, this.next)
        },
        next() {
            this.$router.push({
                path : this.isSimComplete ? '/complete' : ("/sim/" + this.currentAction.slug)
            })
        }
    },
    computed: {
        ...mapGetters([
            "actionFeedback",
            "currentAction",
            "isSimComplete"
        ])
    },
    mounted () {
        gsap.registerPlugin(ScrollToPlugin)
        this.$parent.appHeight()
        const tl = new gsap.timeline();
        tl.to( window, {
            duration : 0.35,
            scrollTo : 0,
            delay : 0.2,
            ease : "sine.out"
        })
        tl.from('#dots, h1, h4, .feedback-item, button', {
            autoAlpha : 0,
            x : "-50px",
            stagger : {amount : 0.35},
            ease : "sine.out"
        }, "+=0.25")
    }
};

</script>

